export default "__VITE_ASSET__ad004f46__"